'use client';

import { styled } from '../../styles';

export const StyledSwipeableDrawerTitle = styled.div(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(5, 4),
  position: 'relative',
}));
